var _excluded = ["label", "name", "id", "value", "disabled", "required", "onChange", "onBlur", "onFocus", "isValid", "autoFocus"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { useFela } from 'react-fela';
import Box from '../box';
import Text from '../text';
var style = function style(_ref) {
  var theme = _ref.theme,
    disabled = _ref.disabled,
    isValid = _ref.isValid;
  return {
    backgroundColor: 'white',
    appearance: 'none',
    boxSizing: 'border-box',
    width: 24,
    height: 24,
    margin: 0,
    padding: 0,
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'border',
    borderRadius: 2,
    position: 'relative',
    cursor: 'pointer',
    outline: 0,
    ':checked': {
      ':before': {
        boxSizing: 'border-box',
        transform: 'translateY(-1px) rotate(45deg)',
        display: 'block',
        content: "''",
        width: 5,
        height: 12,
        position: 'absolute',
        borderRightWidth: 2,
        borderRightStyle: 'solid',
        borderRightColor: 'white',
        borderBottomWidth: 2,
        borderBottomStyle: 'solid',
        borderBottomColor: 'white'
      }
    },
    ':disabled': {
      borderColor: theme.tokens.inputDisabledBorder,
      backgroundColor: theme.tokens.inputControlDisabledBackground,
      cursor: 'not-allowed',
      ':checked': {
        borderColor: theme.tokens.inputDisabledBorder,
        ':before': {
          borderRightColor: 'foreground.disabled',
          borderBottomColor: 'foreground.disabled'
        }
      }
    },
    extend: [{
      condition: !disabled,
      style: {
        ':hover': {
          borderColor: 'foreground.primary'
        },
        ':focus': {
          boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.colors.cornflower500 + '50',
          ':not(:focus-visible)': {
            boxShadow: 'none'
          }
        },
        ':checked': {
          borderColor: 'primary',
          backgroundColor: 'primary',
          ':hover': {
            backgroundColor: 'primaryShade',
            borderColor: 'primary'
          }
        }
      }
    }, {
      condition: !isValid && !disabled,
      style: {
        borderColor: 'foreground.destructive',
        ':checked': {
          borderColor: 'foreground.destructive',
          backgroundColor: 'foreground.destructive',
          ':before': {
            borderRightColor: 'white',
            borderBottomColor: 'white'
          },
          ':hover': {
            borderColor: 'foreground.destructive',
            backgroundColor: 'foreground.destructive'
          }
        }
      }
    }]
  };
};
export default function BaseCheckbox(_ref2) {
  var label = _ref2.label,
    name = _ref2.name,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? name : _ref2$id,
    value = _ref2.value,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur,
    onFocus = _ref2.onFocus,
    _ref2$isValid = _ref2.isValid,
    isValid = _ref2$isValid === void 0 ? true : _ref2$isValid,
    _ref2$autoFocus = _ref2.autoFocus,
    autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
    props = _objectWithoutProperties(_ref2, _excluded);
  var styleProps = {
    isValid: isValid,
    disabled: disabled
  };
  var _useFela = useFela(styleProps),
    css = _useFela.css;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    space: 2,
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement("input", {
    "data-test": props['data-test'],
    type: "checkbox",
    id: id,
    readOnly: typeof onChange === 'undefined',
    name: name,
    checked: value,
    disabled: disabled,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    className: css(style),
    autoFocus: autoFocus
  }), label && typeof label === 'string' ? /*#__PURE__*/React.createElement(Text, {
    variant: "spruce"
  }, label) : label);
}